import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${rem(104)};
  padding-left: ${rem(108)};

  ${(props) => props.$viewport.tablet`
    grid-template-columns: 1fr;
    grid-column-gap: unset;
    justify-items: center;
    grid-row-gap: ${rem(40)};
    padding: ${rem(80)} ${rem(24)} ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)} ${rem(16)};
  `}
`;

export const Content = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${rem(24)};
  padding: ${rem(124)} 0 ${rem(164)};

  .text-primitive {
    text-align: left;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }

  .ck-content h1,
  .ck-content h2,
  .ck-content h3,
  .ck-content h4,
  .ck-content h5,
  .ck-content p {
    margin: 0;
  }

  ${(props) => props.$viewport.tablet`
    padding: 0;

    .text-primitive,
    .ck-content h1,
    .ck-content h2,
    .ck-content h3,
    .ck-content h4,
    .ck-content h5,
    .ck-content p {
      text-align: center;
    }
  `}
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: ${rem(628)};
  height: 100%;
`;

export const Image = withViewportStyle("img")<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: ${({ imageFit }) => imageFit || "cover"};
  object-position: ${({ $position }) => $position};
`;

export const LogoWrapper = withViewportStyle("div")`
  height: 100%;
  display: flex;
  align-items: center;

  ${(props) => props.$viewport.tablet`
    justify-content: center;
  `}
`;

export const Logo = withViewportStyle("img")<{ isLogoResized: boolean }>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(40))};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(40))};
  `}
`;

export const ButtonWrapper = withViewportStyle(StyledButtonContainer)`
  ${(props) => props.$viewport.tablet`
    text-align: center;
  `}

  .button-primitive {
    background: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
    color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  }
`;
